/* Dog Landing Page behaviors — scoped, no external dependencies. */
(function () {
  'use strict';

  function initAnnouncement(root) {
    var bar = root.querySelector('[data-dlp-announcement]');
    if (!bar || bar.dataset.dlpInit) return;
    bar.dataset.dlpInit = '1';
    var messages = bar.querySelectorAll('.dlp-announcement__message');
    if (!messages.length) return;
    var idx = 0;
    var interval = parseInt(bar.dataset.interval, 10) || 5;
    function show(i) {
      idx = (i + messages.length) % messages.length;
      messages.forEach(function (m, j) {
        m.classList.toggle('is-active', j === idx);
      });
      var active = messages[idx];
      if (active.dataset.bgColor) bar.style.backgroundColor = active.dataset.bgColor;
      if (active.dataset.textColor) bar.style.color = active.dataset.textColor;
    }
    show(0);
    var timer = null;
    if (messages.length > 1) {
      timer = setInterval(function () { show(idx + 1); }, interval * 1000);
    }
    var next = bar.querySelector('.dlp-announcement__next');
    if (next) {
      next.addEventListener('click', function () {
        show(idx + 1);
        if (timer) { clearInterval(timer); timer = setInterval(function () { show(idx + 1); }, interval * 1000); }
      });
    }
  }

  function initHeader(root) {
    var header = root.querySelector('[data-dlp-header]');
    if (!header || header.dataset.dlpInit) return;
    header.dataset.dlpInit = '1';
    var burger = header.querySelector('[data-dlp-burger]');
    var drawer = document.getElementById(header.dataset.drawerId || '') || header.querySelector('.dlp-drawer');
    var overlay = header.querySelector('.dlp-drawer-overlay');
    if (!burger || !drawer) return;
    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    burger.addEventListener('click', function () {
      setOpen(!drawer.classList.contains('is-open'));
    });
    if (overlay) overlay.addEventListener('click', function () { setOpen(false); });
    var close = drawer.querySelector('.dlp-drawer__close');
    if (close) close.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  function initHero(root) {
    var hero = root.querySelector('[data-dlp-hero]');
    if (!hero || hero.dataset.dlpInit) return;
    hero.dataset.dlpInit = '1';

    /* ---- Gallery: snap slider + synced thumbnails ---- */
    var track = hero.querySelector('[data-dlp-slider-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-dlp-slide]')) : [];
    var thumbs = Array.prototype.slice.call(hero.querySelectorAll('[data-dlp-thumb]'));
    var suppressSync = 0;

    function markThumb(i) {
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      var active = thumbs[i];
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
    function goToSlide(i, instant) {
      if (!slides[i]) return;
      suppressSync = Date.now() + 600;
      slides[i].scrollIntoView({ behavior: instant ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      markThumb(i);
    }
    function currentSlide() {
      if (!track) return 0;
      var rect = track.getBoundingClientRect();
      var mid = rect.left + rect.width / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var r = s.getBoundingClientRect();
        var c = r.left + r.width / 2;
        var dist = Math.abs(c - mid);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goToSlide(i); });
    });
    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          if (Date.now() < suppressSync) return;
          markThumb(currentSlide());
        });
      }, { passive: true });
    }

    /* ---- Native product form wiring ---- */
    var form = hero.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = form ? form.querySelector('[data-dlp-quantity]') : null;
    var planInput = form ? form.querySelector('[data-dlp-selling-plan]') : null;
    /* Payeo subscription line properties (see the form in dog-hero-product.liquid). */
    var propInputs = form ? Array.prototype.slice.call(form.querySelectorAll('[data-dlp-prop]')) : [];
    function setProp(key, value) {
      propInputs.forEach(function (p) {
        if (p.dataset.dlpProp === key) p.value = value == null ? '' : String(value);
      });
    }
    function money2(cents) {
      return (Math.round(cents) / 100).toFixed(2);
    }
    var atc = hero.querySelector('.dlp-atc');
    var freqSelect = hero.querySelector('[data-dlp-frequency]');
    var bundles = hero.querySelectorAll('.dlp-bundle input[type="radio"]');
    var planRadios = hero.querySelectorAll('input[name="dlp_purchase_option"]');
    var purchaseBox = hero.querySelector('.dlp-purchase-options');
    var badgeFormat = hero.dataset.badgeFormat || '{percent}%';
    var roomFormat = hero.dataset.roomFormat || '';
    var roomFormatOne = hero.dataset.roomFormatOne || roomFormat;
    var roomIcons = hero.querySelector('[data-dlp-room-icons]');
    var roomText = hero.querySelector('[data-dlp-room-text]');
    var houseSvg = roomIcons ? roomIcons.innerHTML : '';

    function readJSON(sel) {
      var el = hero.querySelector(sel);
      if (!el) return {};
      try { return JSON.parse(el.textContent); } catch (e) { return {}; }
    }
    var bundleData = readJSON('[data-dlp-bundles]');
    var variantData = readJSON('[data-dlp-variants]');

    function checkedBundle() {
      return hero.querySelector('.dlp-bundle input[type="radio"]:checked');
    }
    function subscriptionSelected() {
      var r = hero.querySelector('input[name="dlp_purchase_option"]:checked');
      return !!(r && r.value === 'subscription');
    }
    function setText(sel, value) {
      hero.querySelectorAll(sel).forEach(function (el) {
        if (value) el.textContent = value;
      });
    }
    function setCompare(sel, value) {
      hero.querySelectorAll(sel).forEach(function (el) {
        if (value) { el.textContent = value; el.hidden = false; }
        else { el.hidden = true; }
      });
    }
    function savePct(price, compare) {
      if (!compare || !price || compare <= price) return 0;
      return Math.round((1 - price / compare) * 100);
    }

    /* SAVE badges: computed from real prices, per purchase mode (sub vs one-time). */
    function updateBadges(planId, subMode) {
      Object.keys(bundleData).forEach(function (key) {
        var badge = hero.querySelector('[data-dlp-bundle-badge="' + key + '"]');
        if (!badge || badge.dataset.static) return;
        var d = bundleData[key];
        var pct = 0;
        /* Each bundle has its own selling plan id, so resolve the plan per
           bundle (fall back to the bundle's first plan) instead of using only
           the selected bundle's id — otherwise unselected cards kept showing
           the one-time saving while the selected card showed the subscription
           saving, and the badge value jumped on every tap. */
        var bundlePlanId = null;
        if (d.plans) {
          if (planId && d.plans[planId]) bundlePlanId = planId;
          else { var pk = Object.keys(d.plans); if (pk.length) bundlePlanId = pk[0]; }
        }
        if (subMode && bundlePlanId) {
          var plan = d.plans[bundlePlanId];
          var compare = plan.compare_cents || d.onetime.compare_cents || d.onetime.cents;
          pct = savePct(plan.cents, compare);
        } else if (d.onetime) {
          pct = savePct(d.onetime.cents, d.onetime.compare_cents);
        }
        if (pct > 0) {
          badge.textContent = badgeFormat.replace('{percent}', pct);
          badge.hidden = false;
        } else {
          badge.textContent = '';
          badge.hidden = true;
        }
      });
    }

    function updateRoomStrip(qtyLabel, quantity) {
      var n = parseInt(qtyLabel, 10);
      if (isNaN(n)) n = quantity || 1;
      if (roomIcons && houseSvg) {
        var count = Math.max(1, Math.min(n, 4));
        var html = '';
        for (var i = 0; i < count; i++) html += houseSvg;
        roomIcons.innerHTML = html;
      }
      if (roomText) {
        var fmt = n === 1 ? (roomFormatOne || roomFormat) : roomFormat;
        if (fmt) roomText.textContent = fmt.replace(/\{n\}/g, qtyLabel || n);
      }
    }

    function updateUrl(variantId) {
      if (!variantId || !window.history || !window.history.replaceState) return;
      if (!document.querySelector('[data-dlp-hero] form[data-type="add-to-cart-form"]')) return;
      try {
        var url = new URL(window.location.href);
        if (url.pathname.indexOf('/products/') === -1) return;
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* noop */ }
    }

    function update() {
      var b = checkedBundle();
      var planId = freqSelect ? freqSelect.value : null;
      var subMode = subscriptionSelected();

      /* Source of truth: the selected bundle when present, else the single variant. */
      var variantId = b ? b.value : (idInput ? idInput.value : null);
      var quantity = b ? parseInt(b.dataset.quantity, 10) || 1 : 1;
      var priceSet = b ? bundleData[b.dataset.bundleKey] : null;
      var variant = variantData[variantId] || {};

      /* Each package can carry its own selling plan (one plan per variant). The
         frequency select only knows the first package's plan, so when that plan
         is not one of the selected package's own plans, use the package's plan.
         This keeps the hidden selling_plan input and the subscription price
         correct for every package without relying on a later correction. */
      var ownPlans = (priceSet && priceSet.plans) ? priceSet.plans : (variant.plans || null);
      if (ownPlans && !(planId && ownPlans[planId])) {
        var ownIds = Object.keys(ownPlans);
        if (ownIds.length) planId = ownIds[0];
      }

      if (idInput && variantId) idInput.value = variantId;
      if (qtyInput) qtyInput.value = quantity;
      if (planInput) {
        var wantPlan = subMode && planId;
        planInput.value = wantPlan ? planId : '';
        planInput.disabled = !wantPlan;
      }

      /* Payeo line properties are enabled only when the subscription option is
         selected, so one-time purchases are never tagged as subscriptions. The
         values are filled below, once the selected plan's data is known. */
      propInputs.forEach(function (p) { p.disabled = !(subMode && planId); });

      /* Purchase-mode class: flips the subscription checkmarks to red X icons. */
      if (purchaseBox) purchaseBox.classList.toggle('is-onetime', !subMode);

      /* Prices */
      var oneTime = priceSet ? priceSet.onetime : {
        price: variant.price_formatted,
        compare: variant.compare_formatted
      };
      if (oneTime) {
        setText('[data-dlp-price-onetime]', oneTime.price);
        setCompare('[data-dlp-compare-onetime]', oneTime.compare);
      }
      var planPrices = null;
      if (planId) {
        if (priceSet && priceSet.plans) planPrices = priceSet.plans[planId];
        else if (variant.plans) planPrices = variant.plans[planId];
      }
      if (planPrices) {
        setText('[data-dlp-price-sub]', planPrices.price);
        setCompare('[data-dlp-compare-sub]', planPrices.compare || (oneTime && oneTime.compare) || (oneTime && oneTime.price));
      } else if (oneTime) {
        setText('[data-dlp-price-sub]', oneTime.price);
        setCompare('[data-dlp-compare-sub]', oneTime.compare);
      }

      /* Payeo line properties for the selected plan — same keys and formats as
         Payeo's own widget (assignSellingPlan in subscription-widget-new.js). */
      if (subMode && planId) {
        var pd = planPrices || {};
        var unitCents = typeof pd.unit_cents === 'number' ? pd.unit_cents : null;
        var unitCompare = typeof pd.unit_compare_cents === 'number' ? pd.unit_compare_cents : null;
        setProp('plan_id', planId);
        setProp('plan_name', pd.name || (freqSelect && freqSelect.options[freqSelect.selectedIndex] ? freqSelect.options[freqSelect.selectedIndex].textContent.trim() : ''));
        setProp('price', unitCents != null ? money2(unitCents) : '');
        setProp('compare', unitCompare != null && unitCents != null && unitCompare > unitCents ? money2(unitCompare) : '');
        setProp('discount_type', pd.discount_type || '');
        setProp('discount_value', pd.discount_value != null && pd.discount_value !== '' ? pd.discount_value : '');
      }

      /* SAVE badges */
      updateBadges(planId, subMode);

      /* Bundle-driven copy + image + URL */
      if (b) {
        updateRoomStrip(b.dataset.qtyLabel, quantity);
        if (b.dataset.refillLabel) setText('[data-dlp-sub-refills]', b.dataset.refillLabel);
        var imgIndex = parseInt(b.dataset.imageIndex, 10);
        if (!isNaN(imgIndex) && slides[imgIndex]) goToSlide(imgIndex);
        updateUrl(variantId);
      }

      /* Availability */
      var available = priceSet ? priceSet.available : variant.available;
      if (atc && typeof available === 'boolean') {
        var span = atc.querySelector('span');
        if (!available) {
          atc.setAttribute('disabled', 'disabled');
          if (span && atc.dataset.soldOut) span.textContent = atc.dataset.soldOut;
        } else {
          atc.removeAttribute('disabled');
          if (span && atc.dataset.addLabel) span.textContent = atc.dataset.addLabel;
        }
      }
    }

    /* Preselect: honor an explicit checked bundle, else check the one matching the
       URL variant, else the first card. */
    if (bundles.length && !checkedBundle()) {
      var urlVariant = null;
      try { urlVariant = new URL(window.location.href).searchParams.get('variant'); } catch (e) { /* noop */ }
      var match = null;
      bundles.forEach(function (b) { if (urlVariant && b.value === urlVariant && !match) match = b; });
      (match || bundles[0]).checked = true;
    }

    bundles.forEach(function (b) { b.addEventListener('change', update); });
    planRadios.forEach(function (r) { r.addEventListener('change', update); });
    if (freqSelect) freqSelect.addEventListener('change', update);
    update();
    /* First paint should not animate the slider into place. */
    var initB = checkedBundle();
    if (initB) {
      var initIdx = parseInt(initB.dataset.imageIndex, 10);
      if (!isNaN(initIdx) && slides[initIdx]) goToSlide(initIdx, true);
    }
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-dlp-carousel]').forEach(function (car) {
      if (car.dataset.dlpInit) return;
      car.dataset.dlpInit = '1';
      var track = car.querySelector('.dlp-carousel__track');
      var slides = car.querySelectorAll('.dlp-carousel__slide');
      var dotsWrap = car.querySelector('.dlp-carousel__dots');
      if (!track || !slides.length || !dotsWrap) return;
      dotsWrap.innerHTML = '';
      var dots = [];
      slides.forEach(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
        d.addEventListener('click', function () {
          s.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
      function setActive() {
        var rect = track.getBoundingClientRect();
        var mid = rect.left + rect.width / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, i) {
          var r = s.getBoundingClientRect();
          var c = r.left + r.width / 2;
          var dist = Math.abs(c - mid);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
      }
      setActive();
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(setActive);
      }, { passive: true });
    });
  }

  function initVideos(root) {
    root.querySelectorAll('[data-dlp-video]').forEach(function (wrap) {
      if (wrap.dataset.dlpInit) return;
      wrap.dataset.dlpInit = '1';
      var video = wrap.querySelector('video');
      if (!video) return;
      wrap.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          wrap.classList.add('is-playing');
        } else {
          video.pause();
          wrap.classList.remove('is-playing');
        }
      });
      video.addEventListener('ended', function () { wrap.classList.remove('is-playing'); });
    });
  }

  function initReviews(root) {
    var section = root.querySelector('[data-dlp-reviews]');
    if (!section || section.dataset.dlpInit) return;
    section.dataset.dlpInit = '1';
    var items = Array.prototype.slice.call(section.querySelectorAll('.dlp-review-item'));
    var search = section.querySelector('[data-dlp-review-search]');
    var sort = section.querySelector('[data-dlp-review-sort]');
    var rating = section.querySelector('[data-dlp-review-rating]');
    var photosOnly = section.querySelector('[data-dlp-review-photos]');
    var moreBtn = section.querySelector('[data-dlp-review-more]');
    var grid = section.querySelector('.dlp-reviews__grid');
    var pageSize = parseInt(section.dataset.pageSize, 10) || 10;
    var visibleCount = pageSize;

    function matches(item) {
      var q = (search && search.value || '').trim().toLowerCase();
      if (q && item.textContent.toLowerCase().indexOf(q) === -1) return false;
      if (rating && rating.value && item.dataset.rating !== rating.value) return false;
      if (photosOnly && photosOnly.checked && item.dataset.hasPhoto !== '1') return false;
      return true;
    }
    function apply() {
      var list = items.slice();
      if (sort) {
        if (sort.value === 'rating_desc') list.sort(function (a, b) { return (+b.dataset.rating || 0) - (+a.dataset.rating || 0); });
        else if (sort.value === 'rating_asc') list.sort(function (a, b) { return (+a.dataset.rating || 0) - (+b.dataset.rating || 0); });
        else list.sort(function (a, b) { return (+a.dataset.index || 0) - (+b.dataset.index || 0); });
      }
      var shown = 0;
      list.forEach(function (item) {
        grid.appendChild(item);
        var ok = matches(item) && shown < visibleCount;
        item.hidden = !ok;
        if (ok) shown++;
      });
      if (moreBtn) {
        var total = list.filter(matches).length;
        moreBtn.parentElement.querySelectorAll('.dlp-reviews__more').forEach(function (b) {
          b.hidden = total <= visibleCount;
        });
      }
    }
    if (search) search.addEventListener('input', function () { visibleCount = pageSize; apply(); });
    if (sort) sort.addEventListener('change', apply);
    if (rating) rating.addEventListener('change', function () { visibleCount = pageSize; apply(); });
    if (photosOnly) photosOnly.addEventListener('change', function () { visibleCount = pageSize; apply(); });
    if (moreBtn) moreBtn.addEventListener('click', function () { visibleCount += pageSize; apply(); });
    apply();
  }

  function initAll(root) {
    root = root || document;
    initAnnouncement(root);
    initHeader(root);
    initHero(root);
    initCarousels(root);
    initVideos(root);
    initReviews(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
